import * as React from "react";

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "subtle" | "outline" | "ghost";
}

/**
 * Badge component - simple, subtle styling
 */
function Badge({ className = "", variant = "default", ...props }: BadgeProps) {
  const baseClasses =
    "cuadra-inline-flex cuadra-items-center cuadra-rounded-md cuadra-px-3 cuadra-py-1.5 cuadra-text-xs cuadra-font-medium cuadra-font-brand";

  const variantClasses: Record<string, string> = {
    default:
      "cuadra-border cuadra-border-border cuadra-bg-muted cuadra-text-muted-foreground",
    subtle:
      "cuadra-border cuadra-border-border/50 cuadra-bg-muted/50 cuadra-text-muted-foreground",
    outline:
      "cuadra-border cuadra-border-border cuadra-bg-background cuadra-text-foreground",
    ghost: "cuadra-text-muted-foreground",
  };

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant] || variantClasses.default} ${className}`}
      {...props}
    />
  );
}

export { Badge };
